export default __webpack_public_path__ + "static/opdemo2-phone-d8ac8caf3850e292a5b8b6c2e09f2390.png";